import { useEffect, useState } from "react"
import posterNotFound from "../utils/images/posterNotFound.jpeg"
import ServiceStreamingImages from "./ServiceStreamingImages"
import { getDetailsMovies } from "../utils/apis/movies"
import PosterImage from "./skeletons/PosterImage"
import { getDetailsTvshow } from "../utils/apis/tv_show"


const CardMovies = ({ data, country }) => {
    const [movieDetails, setMovieDetails] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        const searchDetailMovie = async () => {
            const result = await getDetailsMovies(data.tmdbId, (e) => {
                setError(e)
                setLoading(false)
            })
            setMovieDetails(result)
            setLoading(false)
        }
        const searchDetailtvShow = async () => {
            const result = await getDetailsTvshow(data.tmdbId, (e) => {
                setError(e)
                setLoading(false)
            })
            setMovieDetails(result)
            setLoading(false)
        }
        if (data.type === "movie") {
            searchDetailMovie()
        } else {
            searchDetailtvShow()
        }
    }, [data])

    const directors = () => {
        return data.directors.map((item) => item)
    }
    const creators = () => {
        return data.creators.map((item) => item)
    }

    const uniqStreamingInfo = () => {
        let streamingInfo = {}
        data.streamingInfo[country].forEach((item) => {
            streamingInfo[item.service] = item
        })
        return streamingInfo
    }

    const handlerPosterimage = () => {
        if (loading) {
            return <PosterImage />
        } else if (error || !movieDetails?.poster_path) {
            return <img src={posterNotFound}
                alt="poster not found" className="inset-0 w-full h-full object-cover scale-90"
                loading="lazy" />
        }
        return <img src={`${process.env.REACT_APP_THEMOVIEDB_IMAGE_HOST}${movieDetails.poster_path}`}
            alt={movieDetails.poster_path}
            className="inset-0 w-full h-full object-cover scale-90"
            loading="lazy" />
    }

    return (
        <div key={data.tmdbId} className="flex font-sans rounded-lg shadow-md bg-white">
            <div className="flex-none lg:w-48 w-40 relative">
                {handlerPosterimage()}
            </div>
            <div className="flex-auto p-6">
                <div className="flex flex-wrap">
                    <h1 className="flex-auto text-lg font-semibold text-slate-900">
                        {data.title}
                    </h1>
                    <div className="text-lg font-semibold text-slate-500 uppercase">
                        {data.year}
                    </div>
                    <div className="w-full flex-none text-xs font-medium text-slate-700">
                        {data.originalTitle}
                    </div>
                    {(data.directors && Object.keys(data.directors).length > 0) && (
                        <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                            Director: {directors()}
                        </div>
                    )
                    }
                    {(data.creators && Object.keys(data.creators).length > 0) && (
                        <div className="w-full flex-none text-sm font-medium text-slate-700 mt-2">
                            Creator: {creators()}
                        </div>
                    )
                    }

                    {Object.keys(data.genres).length > 0 && (
                        data.genres.map((item) => {
                            return (
                                <spam key={item.id} className="p-1 mx-1 flex-none text-xs font-normal text-slate-700 mt-2 rounded-md  bg-rose-500">
                                    {item.name}
                                </spam>
                            )
                        })
                    )
                    }

                </div>
                <div className="flex items-baseline mt-4 border-t border-slate-200">
                    <div className="space-x-2 flex text-sm">
                        {Object.keys(data.streamingInfo).length > 0 && (
                            Object.keys(uniqStreamingInfo()).map((item) => {
                                return (
                                    <ServiceStreamingImages link={uniqStreamingInfo()[item].link} service={uniqStreamingInfo()[item].service} />
                                )
                            })
                        )
                        }
                    </div>
                </div>
            </div>
        </div>)
}

export default CardMovies
